<template>
	<header
		v-if="global.isSessionExpired()"
		:class="[
			!global.isSessionExpired()
				? 'bg-white text-black nav_sesion'
				: 'bg-gray-800 text-white',
		]"
		class="px-2 sticky top-0 z-40"
	>
		<nav
			v-if="
				data_.route.fullPath !== '/' &&
				data_.route.fullPath !== '/login' &&
				data_.route.fullPath !== '/register' &&
				data_.route.fullPath !== '/recovery'
			"
			class="bg-blue_gray-800 text-white"
		>
			<div class="max-w-6xl mx-auto px-4">
				<div class="flex justify-between">
					<div class="flex space-x-7">
						<!-- Primary Navbar items -->
						<div
							class="relative group"
							v-if="$route.name === 'Home'"
						>
							<!-- Mobile menu button -->
							<div class="flex items-center mt-3 mb-2">
								<button
									class="outline-none mobile-menu-button"
									@click="openMenuLeft()"
								>
									<svg
										class="w-6 h-6 text-white"
										:class="`hover:text-${colors.primary}-600`"
										x-show="!showMenu"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											d="M4 6h16M4 12h16M4 18h16"
										></path>
									</svg>
								</button>
							</div>

							<div
								class="w-40 absolute z-10 group-hover:block text-black"
								:class="[!data_.openMenuLeft_ ? 'hidden' : '']"
								v-on:mouseleave="openMenuLeft()"
								v-on:mouseUpCapture="openMenuLeft()"
							>
								<div
									class="absolute z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
								>
									<div
										class="w-full grid grid-cols-1 gap-4 text-left p-2"
									>
										<p>
											<router-link
												to="#recuperacion-facturas"
												@click="
													setHashtagMenu(
														'recuperacion-facturas'
													)
												"
												class="cursor-pointer transition duration-300"
												:class="`hover:text-${colors.primary}-600`"
												>Reclama tu Factura</router-link
											>
										</p>
										<p>
											<router-link
												to="#proceso-reclamacion"
												@click="
													setHashtagMenu(
														'proceso-reclamacion'
													)
												"
												class="cursor-pointer transition duration-300"
												:class="`hover:text-${colors.primary}-600`"
												>¿Cómo Funciona?</router-link
											>
										</p>
										<p>
											<router-link
												to="#servicios"
												@click="
													setHashtagMenu('servicios')
												"
												class="cursor-pointer transition duration-300"
												:class="`hover:text-${colors.primary}-600`"
												>Servicios</router-link
											>
										</p>
										<p>
											<router-link
												to="#opinion-clientes"
												@click="
													setHashtagMenu(
														'opinion-clientes'
													)
												"
												class="cursor-pointer transition duration-300"
												:class="`hover:text-${colors.primary}-600`"
												>Opinión de
												clientes</router-link
											>
										</p>
										<p>
											<router-link
												to="#contacto"
												@click="
													setHashtagMenu('contacto')
												"
												class="cursor-pointer transition duration-300"
												:class="`hover:text-${colors.primary}-600`"
												>Contacto</router-link
											>
										</p>
									</div>
								</div>
							</div>
						</div>

						<div class="mt-3">
							<!-- Website Logo -->
							<router-link
								to="/"
								class="cursor-pointer float-left"
								:class="`hover:text-${colors.primary}-600`"
								@click="setHashtagMenu('')"
							>
								<div class="grid gap-x-5">
									<div>
										<img
											alt="logo"
											src="../../assets/TRECUPERA_new_transparent_white.png"
											class="w-40"
										/>
									</div>
									<div>
										<img
											v-if="logoTenant !== ''"
											:alt="logo"
											:src="logoTenant"
											class="w-40"
										/>
									</div>
								</div>
							</router-link>
						</div>
						<div class="md:w-full w-96 flex flex-cols-2">
							<div
								class="my-auto text-base"
								:class="[
									$route.name === 'Home' && isLocalOrDev()
										? 'w-5/6'
										: 'w-full',
								]"
							>
								Contacta con nosotros en:
								<span
									:class="`cursor-pointer hover:text-${colors.primary}-600`"
									@click="mailTo"
									>{{ data_.companyEmail }}</span
								>
								|
								<span
									:class="`cursor-pointer hover:text-${colors.primary}-600`"
									@click="phoneCall"
									>{{ data_.companyPhone }}</span
								>
							</div>

							<div
								class="w-1/6 my-2 ml-2 lg:block hidden"
								v-if="$route.name === 'Home' && isLocalOrDev()"
							>
								<select
									v-model="data_.domain"
									class="text-sirit_blue-500 md:w-32 w-20"
								>
									<option value="www">trecupera.com</option>
								</select>
							</div>
						</div>
					</div>
					<!-- Secondary Navbar items -->
					<div
						class="lg:w-auto w-40 hidden md:flex items-center lg:space-x-3 lg:text-lg text-xs"
					>
						<router-link
							to="/login"
							class="w-40 cursor-pointer transition duration-300"
							:class="`hover:text-${colors.primary}-600`"
							>Área clientes</router-link
						>

						<router-link
							:to="
								global.isSessionExpired()
									? '/register'
									: currentPath !== '/debt'
									? '/debt'
									: ''
							"
							class="lg:w-28 w-20 py-2 px-2 text-md font-bold text-white rounded transition duration-300"
							:class="`bg-${colors.primary}-500 hover:bg-${colors.primary}-600`"
							>{{
								currentPath !== "/debt"
									? "Reclama YA"
									: "siguiente"
							}}</router-link
						>
					</div>
					<!-- Mobile menu button -->
					<div class="md:hidden flex items-center">
						<button
							class="outline-none mobile-menu-button"
							@click="openMenuMobile()"
						>
							<svg
								class="w-6 h-6 text-black"
								:class="`hover:text-${colors.primary}-600`"
								x-show="!showMenu"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path d="M4 6h16M4 12h16M4 18h16"></path>
							</svg>
						</button>
					</div>
				</div>
			</div>

			<!-- mobile menu -->
			<div class="mobile-menu md:hidden" v-if="data_.openMenuMobile">
				<ul class="">
					<router-link
						to="/login"
						class="cursor-pointer block text-md px-2 py-4 text-white font-semibold"
						:class="`hover:bg-${colors.primary}-600`"
						>Área clientes</router-link
					>
					<router-link
						to="/register"
						class="cursor-pointer block text-md px-2 py-4 text-white font-semibold"
						:class="`hover:bg-${colors.primary}-600`"
						>Reclama ya</router-link
					>
				</ul>
			</div>
		</nav>
	</header>
</template>

<script lang="ts">
	import * as global from "../../api/global";
	import { onBeforeRouteUpdate, useRoute } from "vue-router";
	import { reactive, watch } from "vue";

	export default {
		name: "NavBarTRecupera",
		props: ["type"],

		setup() {
			const state = global.state;
			const { colors } = state.configTenant.template;
			const { logo, tenantId } = state.configTenant;
			const logoTenant =
				logo !== "" && global.getTenantDomain() !== "wivai"
					? require("../../assets/siteImages/" + tenantId + "/" + logo)
					: "";

			const route = useRoute();
			const currentPath = route.fullPath;

			const data_ = reactive({
				openModalNotification: false,
				openMenuMobile: false,
				openMenuLeft_: false,
				domain: !localStorage.getItem("subDomain")
					? ""
					: global.getTenantDomain(),
				companyEmail: "infotrecupera@axactor.com",
				companyPhone: "913246950",
				route: useRoute(),
			});

			const eventOpenModal_notification = () => {
				data_.openModalNotification = !data_.openModalNotification;
			};

			const openMenuMobile = () => {
				data_.openMenuMobile = !data_.openMenuMobile;
			};

			const openMenuLeft = () => {
				data_.openMenuLeft_ = !data_.openMenuLeft_;
			};

			const setHashtagMenu = (hashtag: string) => {
				state.hashtagMenu = hashtag;
			};

			const mailTo = () => {
				window.location.href = `mailto: ${data_.companyEmail}`;
			};

			const phoneCall = () => {
				window.location.href = `tel: ${data_.companyPhone}`;
			};

			const isLocalOrDev = () => {
				return global.isLocalDomain() || global.isDevOrPreDomain();
			};

			return {
				currentPath,
				global,
				data_,
				colors,
				eventOpenModal_notification,
				openMenuMobile,
				state,
				logoTenant,
				logo,
				setHashtagMenu,
				openMenuLeft,
				mailTo,
				phoneCall,
				isLocalOrDev,
				onBeforeRouteUpdate,
				watch,
			};
		},
	};
</script>

<style>
	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: white;
	}

	#nav a.router-link-exact-active {
		color: #bababb;
	}

	.nav_sesion a {
		color: rgb(0, 0, 0) !important;
	}

	.nav_sesion a.router-link-exact-active {
		color: #bababb !important;
	}

	.nav_sesion_other a {
		color: white !important;
	}

	.nav_sesion_other {
		color: white !important;
	}
</style>
